import { baseColors } from "@Constants/baseStyles"
import { StyleSheet } from "react-native"
import { RFValue } from "react-native-responsive-fontsize"

const styles = StyleSheet.create({
    container: {
        padding: 15,
        borderRadius: 15,
        backgroundColor: baseColors.green.light,
        marginBottom: 20
    },
    header: {
        flexDirection: "row",
        alignItems: "center",
        justifyContent: "space-between"
    },
    leftContent: {
        flexDirection: "row",
        alignItems: "center",
        flex: 0.7
    },
    userInfos: {
        marginLeft: RFValue(10)
    },
    createdDate: { color: baseColors.green.primary, marginTop: RFValue(4) },
    avatar: { backgroundColor: "grey", borderRadius: 7 },
    content: {
        marginVertical: RFValue(20)
    },
    title: { color: baseColors.green.primary, marginBottom: RFValue(20) },
    footer: {
        flexDirection: "row",
        alignItems: "center",
        justifyContent: "space-between"
    },
    cancel: {
        textDecorationLine: "underline",
        color: baseColors.green.primary,
        marginTop: RFValue(50)
    },
    btn: {
        justifyContent: "space-around",
        alignItems: "center"
    },
    category: {
        flexDirection: "row",
        justifyContent: "space-between",
        alignItems: "flex-start"
    },
    emptyDiscussionsContainer: {
        flex: 1,
        flexDirection: "row",
        justifyContent: "center",
        alignItems: "center",
        marginVertical: 70
    },
    checkBoxLabel: { flex: 1, marginLeft: 7, color: baseColors.orange.primary },
    checkBoxLabelGreen: { flex: 1, marginLeft: 7, color: baseColors.black },
    firstCheckBoxContent: { flexDirection: "row", alignItems: "center", marginBottom: 25 },
    secondCheckBoxContent: { flexDirection: "row", alignItems: "center", marginBottom: 25 },
    thirstCheckBoxContent: { marginBottom: 25 }
})

export default styles
